import { render, staticRenderFns } from "./ConfirmAtivarDeleteAvisoModal.vue?vue&type=template&id=2aef24eb&"
import script from "./ConfirmAtivarDeleteAvisoModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAtivarDeleteAvisoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports